import { HisItemParameter } from "../../his/behavior";

export class HisInformationNameEmptyValidationMaster {
  static shouldValidateNameEmpty(hisItemParameter: HisItemParameter): boolean {
    return !hisItemParameter || ((hisItemParameter.key !== "PRINT_DATE") && (hisItemParameter.key !== "PRINT_TIME"));
  }
}
